import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

interface AppViewPersonalization {
  skippedCount?: number;
  alreadyEnabled?: boolean;
}

const remoteEnableStoreConfig = {
  id: 'remoteEnable',
  initialState: {
    skippedCount: 0,
    alreadyEnabled: false
  },
  methods: (set, get) => ({
    setSkippedCount: (skippedCount: number) => {
      set({ skippedCount });
    },
    setAlreadyEnabled: (alreadyEnabled: boolean) => {
      set({ alreadyEnabled });
    },
    initializeFromAppContext: (
      appViewPersonalization: AppViewPersonalization | null
    ) => {
      if (!get().skippedCount && appViewPersonalization) {
        const skippedCount = appViewPersonalization?.skippedCount || 0;
        set({ skippedCount });
      }
      if (!get().alreadyEnabled && appViewPersonalization) {
        const alreadyEnabled = appViewPersonalization?.alreadyEnabled || false;
        set({ alreadyEnabled });
      }
    },
    reset: () => {
      set({ skippedCount: 0, alreadyEnabled: false });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true,
    scope: 'global'
  }
};

export const useRemoteEnableStore = createStore(remoteEnableStoreConfig);
